import { cva, VariantProps } from 'class-variance-authority';

const stepVariants = cva('w-[20px] h-[20px] flex items-center justify-center rounded-bzc-circular caption-xsmall-semibold px-[7px] py-[1px] ', {
  variants: {
    variant: {
      before: 'bg-neutral-background-low text-primary-foreground-main',
      inProgress: 'bg-primary-background-main text-primary-foreground-inverse-main',
      done: 'bg-neutral-background-low text-primary-foreground-main'
    }
  },
  defaultVariants: {
    variant: 'before'
  }
});

interface StepProps extends VariantProps<typeof stepVariants> {
  number: number;
  className?: string;
}

export function Step({ number, className, variant, ...props }: StepProps) {
  return (
    <div role={'status'} aria-label={`Step ${number}`} className={stepVariants({ variant, className })} {...props}>
      {number}
    </div>
  );
}
